import { createSelector } from 'reselect';
import { get } from 'lodash/fp';
import { createPrefixer } from '@mews-commander/utils';
import parentSelector from '../selector';

export const MODULE_NAME = 'messages';
export const prefix = createPrefixer(MODULE_NAME);
export const moduleSelector = createSelector(parentSelector, get(MODULE_NAME));
